'use strict';

var React = require('react');
var jsUtils = require('@swiggy-private/js-utils');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const ShowAllButtonUx4 = styled__default.default.button(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
    fontSize: "0.9rem",
    fontWeight: 600,
    display: "inline-block",
    background: "none",
    border: "none",
    boxShadow: "none",
    padding: "9px 0",
    margin: 0,
    marginLeft: theme.spacing.xLarge,
    "&:before": {
        content: '"+"',
        marginRight: "3px",
    },
}));

const ShowAll = (props) => {
    const { showAllButtonText = "MORE", onClick, moreCount } = props;
    const SHOW_ALL_LABEL = "Show {0} more options";
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.bold" },
            React__default.default.createElement(ShowAllButtonUx4, { onClick: onClick, "aria-label": jsUtils.format(SHOW_ALL_LABEL, moreCount) },
                moreCount,
                " ",
                showAllButtonText.toLowerCase()))));
};
var ShowAll$1 = React__default.default.memo(ShowAll);

const PartialList = (props) => {
    const [showAll, setShowAll] = React.useState(false);
    const { data, adjustRowCount = 2, visibleRows = 1, onShowAll = () => { }, renderRow, showAllButtonText, } = props;
    const getDefaultVisibleCount = () => {
        if (data.length > adjustRowCount + visibleRows) {
            return visibleRows;
        }
        return data.length;
    };
    const getMoreCount = () => {
        const visibleRowsCount = getDefaultVisibleCount();
        return data.length - visibleRowsCount;
    };
    const showAllFn = () => {
        onShowAll();
        setShowAll(true);
    };
    const renderVisibleRows = () => {
        const visibleRowsCount = getDefaultVisibleCount();
        const visibleData = visibleRowsCount === data.length ? data : data.slice(0, visibleRowsCount);
        return visibleData.map(renderRow);
    };
    const renderRemainingRows = () => {
        const visibleRowsCount = getDefaultVisibleCount();
        const moreCount = getMoreCount();
        if (moreCount === 0) {
            return null;
        }
        if (showAll) {
            return data
                .slice(visibleRowsCount)
                .map((dataItem, dataIndex) => (React__default.default.createElement("div", { key: dataIndex }, renderRow(dataItem, visibleRowsCount + dataIndex))));
        }
        return (React__default.default.createElement(ShowAll$1, { onClick: showAllFn, moreCount: moreCount, showAllButtonText: showAllButtonText }));
    };
    return (React__default.default.createElement("div", null,
        renderVisibleRows(),
        renderRemainingRows()));
};
var PartialList$1 = React__default.default.memo(PartialList);

exports.PartialList = PartialList$1;
//# sourceMappingURL=PartialList-Cdl4XIGT.js.map
